const initialState = {
	org: undefined,
	orgTitle: undefined,
	orgId: undefined,
};

const roleManager = (state = initialState, action) => {
	switch (action.type) {
		case "SET_ORGANIZATION":
			return Object.assign({}, state, {
				org: action.payload?.org,
				orgTitle: action.payload?.orgTitle,
				orgId: action.payload?.orgId,
			});
		default:
			return state;
	}
};

export default roleManager;
